(function() {
    'use strict';

const TR = angular.module('TR');
TR.directive('globalWaiverText', GlobalWaiverText);

function GlobalWaiverText() {
    return {
        restrict: 'E',
        scope: {
            waiverText: '=',
        },
        controllerAs: 'cm',
        templateUrl: 'partials/home/directivetemplate?type=GlobalWaiverText',
        link($scope, $element) {
            if (!$scope.waiverText || $scope.waiverText == null) {
                return;
            }

            $scope.showImportantInfo = false;

            async function fetchWaiverText() {
                const response = await $scope.waiverText;
                return response;
            }

            async function waiverTextReady() {

                const getWaiverText = await fetchWaiverText();

                if (!getWaiverText.length) { return; }

                const el = $element[0];
                const globalWaiverTerms = el.querySelector('.globalWaiverTerms');

                function attachLightbox(e) {
                    e.preventDefault();
                    $scope.selectedImportantInfo = '';
                    $scope.showImportantInfo = true;
                    $scope.$apply();
                }

                globalWaiverTerms.addEventListener('click', attachLightbox);

                $scope.$on('$destroy', function() {
                    globalWaiverTerms.removeEventListener('click', attachLightbox);
                });
            }
            waiverTextReady();
        }
    };
}

})();
